module.exports = __webpack_public_path__ + "assets/img/modal-avatar-421baed2.png";